<template>
  <div style="margin-top:10px;">
    <b-tooltip position="is-left" :label="$t('popupDrag.title')">
      <div
        style="margin-right:10px;cursor:pointer"
        @click="isActiveDragPopup()"
      >
        <b-icon pack="fas" icon="list-ol" size="is-small"></b-icon>
      </div>
    </b-tooltip>
    <b-tooltip position="is-left" :label="this.$t('sondage.deleted-section')">
      <div style="margin-right:10px;cursor:pointer" @click="removeSection">
        <b-icon pack="fas" icon="trash-alt" size="is-small"></b-icon>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
import EventBus from '@/eventBus'

export default {
  name: 'BlockButtonsSection',
  props: {
    isActive: {
      type: Boolean,
      required: true,
      default: false
    },
    indexSection: {
      type: Number,
      required: true
    }
  },
  methods: {
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    isActiveDragPopup () {
      EventBus.$emit('is-active-popup-drag', {
        type: 'openPopup',
        index: this.indexSection
      })
    },
    removeSection () {
      this.sendMessageToParent('scrollToTop')
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t('sondage.non'),
        confirmText: this.$i18n.t('sondage.oui'),
        message: this.$i18n.t('popupSondage.delete-section'),
        onConfirm: () => this.$store.commit('REMOVE_SECTION', this.indexSection)
      })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/question/section/BlocButtonsSection.vue